import { getCachedData, setCachedData } from './cache';

// API URL configuration that works for both preview and deployment
// Preview (localhost:3000): Uses localhost:8001 for direct backend access
// Deployment (acad.co.in): Uses same origin with /api prefix, Kubernetes routes to backend
export const getApiBaseUrl = () => {
  // Check if we're in preview environment (localhost)
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:8001';
  }
  
  // Deployment: use same origin (Kubernetes ingress routes /api/* to backend)
  return window.location.origin;
};

const API_URL = getApiBaseUrl();

// Optimized getProjects with caching
export const getProjects = async (params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const url = `${API_URL}/api/projects${queryParams ? `?${queryParams}` : ''}`;
  
  // Check cache first
  const cacheKey = `projects_${queryParams}`;
  const cachedData = getCachedData(cacheKey);
  if (cachedData) {
    return cachedData;
  }
  
  const response = await fetch(url);
  if (!response.ok) throw new Error('Failed to fetch projects');
  
  const data = await response.json();
  
  // Cache the response
  setCachedData(cacheKey, data);
  
  return data;
};

// Optimized getProjectBySlug with caching
export const getProjectBySlug = async (slug) => {
  // Check cache first
  const cacheKey = `project_${slug}`;
  const cachedData = getCachedData(cacheKey);
  if (cachedData) {
    return cachedData;
  }
  
  const response = await fetch(`${API_URL}/api/projects/slug/${slug}`);
  if (!response.ok) throw new Error('Failed to fetch project');
  
  const data = await response.json();
  
  // Cache the response
  setCachedData(cacheKey, data);
  
  return data;
};

// Contact form submission
export const submitContactForm = async (formData) => {
  const response = await fetch(`${API_URL}/api/contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  });

  if (!response.ok) throw new Error('Failed to submit form');
  
  return response.json();
};
